export const data: any = {
  NEXT_PUBLIC_BASE_URL: "https://civilconstruction.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://civilconstruction.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "civil",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "1nvkn1423yot",
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_ONETRUST_ID: "019d6926-ec98-79ef-b288-46be8d71e659",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "prod_civil_trmb",
  NEXT_PUBLIC_VWO_ACCOUNT_ID: "1212944",
}
